






































import Component from "vue-class-component";
import VueTags from "@/components/tags.vue";
import VueUserName from "@/components/user-name.vue";
import VueMetadata from './metadata.vue';
import { mapActions, mapGetters } from "vuex";
import { default as mixins } from '../mixins/user';
import { Mixins, Prop } from "vue-property-decorator";
import { Guide } from '@/types/models';
import { GuideMixin } from "@/components/mixins/guide";
import VueProgressBar from "@/components/progress-bar.vue";

@Component({
  mixins: [mixins],
  components: {
    'vue-tags': VueTags,
    'vue-user-name': VueUserName,
    'vue-metadata': VueMetadata,
    'vue-progress-bar': VueProgressBar
  },
  methods: {
    ...mapGetters('user', ['isAuthorized']),
    ...mapActions('guides', ['vote', 'subscribe'])
  }
})
export default class VueHeadline extends Mixins(GuideMixin) {
  @Prop()
  protected readonly guide!: Guide;
}
